import { useEffect } from 'react';

import { subscribeFilterCascadeToasts } from './filter-cascade-toasts';
import { subscribeScrollCommands } from './scroll-commands';

/**
 * Mounts every planner store side-effect subscriber (toasts, DOM scrolls).
 * Slices only DESCRIBE side effects as state (filterCascadeNotice,
 * pendingScrollCommand); these subscribers EXECUTE them. Returns the combined
 * unsubscribe. Idempotence is the caller's job — mount exactly once.
 */
export const mountPlannerStoreEffects = (): (() => void) => {
  const unsubscribers = [subscribeFilterCascadeToasts(), subscribeScrollCommands()];
  return () => unsubscribers.forEach(unsubscribe => unsubscribe());
};

/** Mounts the planner store effects for the lifetime of the planner page. */
export const usePlannerStoreEffects = (): void => {
  useEffect(() => mountPlannerStoreEffects(), []);
};
